import { render, staticRenderFns } from "./viewers.vue?vue&type=template&id=076a5b6b&scoped=true"
import script from "./viewers.vue?vue&type=script&lang=js"
export * from "./viewers.vue?vue&type=script&lang=js"
import style0 from "./viewers.vue?vue&type=style&index=0&id=076a5b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a5b6b",
  null
  
)

export default component.exports